import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import SvgIcon from "@material-ui/core/SvgIcon";
import IconButton from "@material-ui/core/IconButton";
// import { OBJModel, DirectionLight, AmbientLight } from "react-3d-viewer";
import { ObjModel, DirectionLight } from "../../../../react-model-viewer";
import { Vector3 } from "three";

//get basic state for a Dialog
function useDialog() {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }
  return [open, handleClickOpen, handleClose];
}

function ModelButton(props) {
  const [open, handleClickOpen, handleClose] = useDialog();
  const { obj_model, button, buttonText } = props;
  return (
    <div>
      {button ? (
        <Button color="secondary" onClick={handleClickOpen}>
          {buttonText}
        </Button>
      ) : (
        <IconButton onClick={handleClickOpen} title="查看模型">
          <SvgIcon>
            <path d="M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z" />
          </SvgIcon>
        </IconButton>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>模型查看 </DialogTitle>
        <DialogContent>
          <ObjModel
            src={obj_model}
            texPath=""
            width="400"
            height="400"
            position={{ x: 0, y: 0, z: 0 }}
          >
            {/* <AmbientLight color="#AB9B7F" /> */}
            {/* <DirectionLight color="#AB9B7F" position={new Vector3(0, 1, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, -1, 0)} /> */}
            {/* <DirectionLight color="#AB9B7F" position={new Vector3(1, 0, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(-1, 0, 0)} /> */}
            <DirectionLight color="#AB9B7F" position={new Vector3(1, 0, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(-1, 0, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, 0, 1)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, 0, -1)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, 1, 0)} />
            <DirectionLight color="#AB9B7F" position={new Vector3(0, -1, 0)} />
          </ObjModel>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            关闭
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ModelButton;
